export enum ConvoEndLogicType {
    None = '',
    LogicJump = 'logic-jump',
    DiscoveryMenu = 'discovery-menu',
}
